import { gql } from '@apollo/client';

export const CREATE_PAYMENT_INTENT = gql`
  mutation wInitPayment($uid: UUID!, $local: Boolean!) {
    wInitPayment(uid: $uid, local: $local)
  }
`;

export interface PaymentInfo {
  appId: string;
  region: string;
  currency: string;
  amount: number;
  intentType: string;
  timestamp: number;
  email: string;
  paymentMethods?: string[];
  paymentToken: string;
  paymentReference: string;
}

type InitPaymentResult = 'SUBSCRIPTION_EXISTS';
export interface CREATE_PAYMENT_INTENT_TYPE {
  wInitPayment: {
    paymentInitData: PaymentInfo;
    result?: InitPaymentResult;
  };
}
